"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleWorldCharacterClick = void 0;
const retrommo_types_1 = require("retrommo-types");
const WorldCharacter_1 = require("../classes/WorldCharacter");
const addWorldCharacterMarker_1 = require("./addWorldCharacterMarker");
const closeWorldMenus_1 = require("./world-menus/closeWorldMenus");
const pixel_pigeon_1 = require("pixel-pigeon");
const definables_1 = require("definables");
const selectedPlayerWorldMenu_1 = require("../world-menus/selectedPlayerWorldMenu");
const state_1 = require("../state");
const handleWorldCharacterClick = (worldCharacterID) => {
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldCharacterID);
    if (state_1.state.values.selectedPlayerID === worldCharacter.playerID) {
        selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.close();
    }
    else if (worldCharacter.hasMarkerEntity()) {
        (0, pixel_pigeon_1.emitToSocketioServer)({
            data: { playerID: worldCharacter.playerID },
            event: "world/cancel-invite",
        });
    }
    else {
        (0, closeWorldMenus_1.closeWorldMenus)();
        state_1.state.setValues({ selectedPlayerID: worldCharacter.playerID });
        selectedPlayerWorldMenu_1.selectedPlayerWorldMenu.open({ playerID: worldCharacter.playerID });
        (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(worldCharacter.id, retrommo_types_1.MarkerType.Selected);
    }
};
exports.handleWorldCharacterClick = handleWorldCharacterClick;
